import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import CourseOffered from "../pages/CourseOffered";
import EnrollFormModal from "../pages/EnrollFormModal"; 
import "../styles/TrainerDetails.css";
import "../styles/CourseOffered.css"; 

const TrainerDetail = () => {
  const location = useLocation();
  const { trainer } = location.state || {};
  const [isLoggedinUser] = useState(false);
  const [showEnrollForm, setShowEnrollForm] = useState(false); 

  if (!trainer) {
    return <div>Trainer data not found. Please go back.</div>;
  }

  return (
    <div className="trainer-details-container">
   
      {/* <div className="top-enroll-container">
        <button
          className="top-enroll-btn"
          onClick={() => setShowEnrollForm(true)}
        >
          Enroll Now
        </button>
      </div> */}

      <div className="trainer-info-card">
        <div className="trainer-left">
          {trainer.photo ? (
            <img
              src={trainer.photo}
              alt={trainer.name}
              className="trainer-photo"
            />
          ) : (
            <div>No Photo Available</div>
          )}
          <h2>{trainer.name}</h2>
          {isLoggedinUser ? (
            <>
              <p>
                <strong>Phone:</strong> {trainer.contact}
              </p>
              <p>
                <strong>Email:</strong> {trainer.email}
              </p>
            </>
          ) : (
            <div className="not-registered">
              <p style={{ fontStyle: "italic", color: "#888" }}>
                Contact info available after login.
              </p>
            </div>
          )}
        </div>

        <div className="trainer-right">
          <h1>{trainer.course}</h1>
          <p>
            {trainer.courseDescription || "No course description available."}
          </p>
        </div>
      </div>

    
      <div className="trainer-courses-container">
        <CourseOffered context="trainer" trainer={trainer} />
      </div>

      
      <EnrollFormModal
        isOpen={showEnrollForm}
        onClose={() => setShowEnrollForm(false)}
      />
    </div>
  );
};

export default TrainerDetail;
